import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

/** Punch card row shown by the Como punch cards block in CB2 preview. */
export type ComoPunchCardsPreviewPunchCard = {
  name?: string;
  description?: string;
  required_punches?: number;
  punches?: number;
  fully_punched?: boolean;
  image?: string;
  key?: string;
};

/** Serializable preview VM for `ComoPunchCardsBlockComponent`. */
export type ComoPunchCardsBlockScenarioContent = {
  comoUser: {
    points_balance: {
      used_by_payment: boolean;
      monetary: number;
      non_monetary: number;
    };
    credit_balance: {
      used_by_payment: boolean;
      monetary: number;
      non_monetary: number;
    };
    assets: readonly [];
    punch_cards?: readonly ComoPunchCardsPreviewPunchCard[];
  } | null;
};

export const COMOPUNCHCARDSBLOCK_LEGACY_FIELD_ORDER = [];

const {
  comoPunchCardsBlockDescriptor: _generatedComoPunchCardsBlockDescriptor,
  comoPunchCardsBlockBlocDefinition,
  comoPunchCardsBlockDashboardLayout,
  comoPunchCardsBlockConfig,
  comoPunchCardsBlockResolveConfig,
  comoPunchCardsBlockProperties,
  comoPunchCardsBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    name: "Como - Punch cards",
    componentType: 'ComoPunchCardsBlockComponent',
    category: 'como',
    description: "Como - Punch cards.",
    keywords: [],
    allowed_in: ["CartPage"],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function comoPunchCardsBlockDescriptor(): IBlockDescriptor;
export function comoPunchCardsBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function comoPunchCardsBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedComoPunchCardsBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedComoPunchCardsBlockDescriptor, comoPunchCardsBlockProperties, fieldOrder);
}

export {
  comoPunchCardsBlockBlocDefinition,
  comoPunchCardsBlockDashboardLayout,
  comoPunchCardsBlockProperties,
  comoPunchCardsBlockConfig,
  comoPunchCardsBlockResolveConfig,
  comoPunchCardsBlockDefinitionSetupScenarios,
};

export type ComoPunchCardsBlockConfig = typeof comoPunchCardsBlockConfig;
